import { Grid, makeStyles} from '@material-ui/core';
import {prettyDate} from '../../../config/dateFormatting'
import { IAlreadyBooked, IMenuItem, ISelectableSeating } from '../../../interface/interface';
import { CustomCheckBox } from '../../../components/ui/CustomCheckBox';

const useStyles = makeStyles((theme: any) => ({
    seatingContainer: {
        display:'grid',
        gridTemplateColumns: '70% 30%',
        background: '#FFFFFF',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderLeft: '2px solid red',
        padding: 7,
        cursor: 'pointer',
    }, 
    seatingTitle: {
        fontSize: 12,
        fontWeight: 700
    }, 
    seatingTime: {
        fontSize: 10,
        paddingBottom: 5
    }, 
    availableSeat: {
        fontSize: 8,
        color: 'red'
    },
    seatingSelectedContainer:{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        padding: 8
    }
}));

interface Props { 
    menuItemOnDate: IMenuItem;
    menuItemsOnDate?: IMenuItem[];
    setMenuItemsOnDate?: React.Dispatch<React.SetStateAction<any>>;
    index?:number;
    menuItemsOnDates?: IMenuItem[][];
    setMenuItemsOnDates?: React.Dispatch<React.SetStateAction<IMenuItem[][]>>;
    selectableSeating: ISelectableSeating;
    eaterGroupBookings?: IAlreadyBooked;
    eaterGroupName: string;
    isWeekBooking: boolean;

    seatingCapacity: number;
}

export const SeatingContainer: React.FC<Props> = ({selectableSeating,menuItemOnDate,menuItemsOnDate,setMenuItemsOnDate,index,menuItemsOnDates,setMenuItemsOnDates,eaterGroupBookings,eaterGroupName,isWeekBooking,seatingCapacity}) => {
    const classes = useStyles();
    
    var borderColor = "#999999";
    var selectedColor = "#FFFFFF";
    var cursor = "pointer";
    if(seatingCapacity >= 20){
        borderColor = '#43CA21';
    } else if (seatingCapacity <= 20 && seatingCapacity > 10){
        borderColor = '#EE9F29';
    } else if (seatingCapacity <= 10 && seatingCapacity > 0){
        borderColor = '#AC1B1B';
    } else if(seatingCapacity <= 0 ){
        borderColor = '#616161';
        cursor = 'default'
    }

    if(menuItemOnDate.quantity > seatingCapacity){
        borderColor = '#616161';
        cursor = 'default'
    }

    if(selectableSeating.selected){
        selectedColor = 'rgba(63, 127, 191, 0.47)';
    } else {
        selectedColor = "#FFFFFF";
    }
    
    const borderLeftColor = {
        borderColor: borderColor,
        cursor: cursor
    }
    const availableColor = {
        color: borderColor
    }

    const updateSelectedDatesBooking = () => {
        if(seatingCapacity > 0 && menuItemsOnDate && setMenuItemsOnDate){
            let tmpMenuItemOnDate : IMenuItem[] = [];
            selectableSeating.selected = !selectableSeating.selected

            menuItemsOnDate.forEach((menuItemOnDateItem,index, object) => {
                if(menuItemOnDateItem=== menuItemOnDate){
                    menuItemOnDateItem.selectableSeatings.forEach((selectableSeatingItem) =>{
                        if(selectableSeatingItem.seating.content.id=== selectableSeating.seating.content.id){
                            selectableSeatingItem.selected = selectableSeating.selected;
                        } else {
                            selectableSeatingItem.selected = false;
                        }
                    })
                }
                tmpMenuItemOnDate.push(menuItemOnDateItem)
            })
            setMenuItemsOnDate(tmpMenuItemOnDate);
        }
    }

    const updateSelectedDatesWeekBooking = () => {
        if(seatingCapacity > 0 && index !== undefined && menuItemsOnDates && setMenuItemsOnDates){
            let tmpMenuItemOnDate : IMenuItem[] = [];
            selectableSeating.selected = !selectableSeating.selected

            menuItemsOnDates[index].forEach((menuItemOnDateItem,i) => {
                if(menuItemOnDateItem=== menuItemOnDate){
                    menuItemOnDateItem.selectableSeatings.forEach((selectableSeatingItem) =>{
                        if(selectableSeatingItem.seating.content.id=== selectableSeating.seating.content.id){
                            selectableSeatingItem.selected = selectableSeating.selected;
                        } else {
                            selectableSeatingItem.selected = false;
                        }
                    })
                }
                tmpMenuItemOnDate.push(menuItemOnDateItem)
            })

           // Set menuItemsOnDates
            const tmpMenuItemsOnDate : IMenuItem[][] = []
            menuItemsOnDates.forEach((menuItemsOnDate,i) => {
                if(index=== i){
                    tmpMenuItemsOnDate.push(tmpMenuItemOnDate)
                } else {
                    tmpMenuItemsOnDate.push(menuItemsOnDate)
                }
            })

            if(tmpMenuItemOnDate.length > 0){
                setMenuItemsOnDates(tmpMenuItemsOnDate)
            }
        }
    }

    return (
        <>
            {
                isWeekBooking ? 
                <div className={classes.seatingContainer} style={borderLeftColor} onClick={() => updateSelectedDatesWeekBooking()}>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="flex-start"  
                    >
                        <div className={classes.seatingTitle}>
                            {selectableSeating.seating.content.seatingName}
                        </div>
                        <div className={classes.seatingTime}>
                            {prettyDate(selectableSeating.seating.content.seatingStart,true,false)}
                        </div>
                        <div className={classes.availableSeat} style={availableColor}>
                            {seatingCapacity > 0 ? seatingCapacity : 0} available {eaterGroupBookings && <b style={{color: 'black'}}>{" - " + eaterGroupBookings?.quantity + " x " + eaterGroupName}</b>}
                        </div>
                    </Grid>
                    <div className={classes.seatingSelectedContainer}>
                        <CustomCheckBox selected={selectableSeating.selected} />
                    </div>
                </div>
                :
                <div className={classes.seatingContainer} style={borderLeftColor} onClick={() => updateSelectedDatesBooking()}>
                     <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="flex-start"  
                    >
                        <div className={classes.seatingTitle}>
                            {selectableSeating.seating.content.seatingName}
                        </div>
                        <div className={classes.seatingTime}>
                            {prettyDate(selectableSeating.seating.content.seatingStart,true,false)}
                        </div>
                        <div className={classes.availableSeat} style={availableColor}>
                            {seatingCapacity > 0 ? seatingCapacity : 0} available 
                        </div>
                        <div className={classes.availableSeat}>
                            {eaterGroupBookings && <b style={{color: 'black'}}>{eaterGroupBookings?.quantity + " x " + eaterGroupName}</b>}
                        </div>
                    </Grid>
                    <div className={classes.seatingSelectedContainer}>
                        <CustomCheckBox selected={selectableSeating.selected} />
                    </div>
                </div>
            }
        </>
    );
}